import { Grid, Paper } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

import { Toggle } from "../../atoms/Input/Toggle";
import {
  SubHeader,
  SubHeader2,
} from "../../atoms/Typography/SubHeader/SubHeader";

export const DoctorInfoSection2 = ({ data }) => {
  const { t } = useTranslation();
  return (
    <>
      <Paper variant="White0.5" sx={{ width: "1264px" }}>
        <Grid container direction={"row"} justifyContent={"space-between"}>
          <Grid item>
            <Stack>
              <SubHeader text={t("glossary:doctor-details.slot-duration")} />
              <SubHeader2 text={"15 minutes"} />
            </Stack>
          </Grid>


          <Grid item>
            <Toggle
              disabled={true}
              defaultChecked={true}
              header={t("glossary:doctor-details.call-back-request")}
            />
          </Grid>
          <Grid item>
            <Toggle
              disabled={true}
              defaultChecked={true}
              header={t("glossary:doctor-details.instant-consultations")}
              text={"15 minutes"}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};
